module.exports = __webpack_public_path__ + "static/media/farming-in-forests-article.0b92e5a6.jpg";